import {
	ADD_DICTEXPENSE,
	UPDATE_DICTEXPENSE,
	DELETE_DICTEXPENSE,
	GET_DICTEXPENSE_LIST,
} from '../constant';
import {
	getDictExpensesApi,
	addDictExpenseApi,
	updateDictExpenseApi,
	deleteDictExpenseApi,
} from '../../api';

export const getDictExpenses = (data) => ({
	type: GET_DICTEXPENSE_LIST,
	data,
});

export const addDictExpense = (data) => ({
	type: ADD_DICTEXPENSE,
	data,
});

export const updateDictExpense = (data) => ({
	type: UPDATE_DICTEXPENSE,
	data,
});

export const deleteDictExpense = (data) => ({
	type: DELETE_DICTEXPENSE,
	data,
});

export const getDictExpensesAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getDictExpensesApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getDictExpenses({
							data: (data.value as any)?.data ?? [],
							total: totalpage,
						})
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const addDictExpenseAsync = (data) => async (dispatch) => {
	try {
		const response = await addDictExpenseApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addDictExpense(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateDictExpenseAsync = (data) => async (dispatch) => {
	try {
		const response = await updateDictExpenseApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(updateDictExpense(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteDictExpenseAsync = (data) => async (dispatch) => {
	try {
		const response = await deleteDictExpenseApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(deleteDictExpense(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
